import { render, staticRenderFns } from "./ImportStatementButton.vue?vue&type=template&id=6b008313&"
import script from "./ImportStatementButton.vue?vue&type=script&lang=js&"
export * from "./ImportStatementButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports